module.exports = __webpack_public_path__ + "img/878-f02b2c.png";